"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.School = void 0;
var React = require("react");
var School = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "0 0 24 24" },
    React.createElement("defs", null,
        React.createElement("path", { id: "SCHOOL-SVG-COMPONENT-ICON-PATH", d: "M20 15h-3v-3l-4-3.2V7h2V4h-4v4.8L7 12v3H4v5h6v-4h4v4h6z" })),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("mask", { id: "SCHOOL-SVG-COMPONENT-ICON-MASK", fill: "#fff" },
            React.createElement("use", { xlinkHref: "#SCHOOL-SVG-COMPONENT-ICON-PATH" })),
        React.createElement("g", { fill: "#00242D", mask: "url(#SCHOOL-SVG-COMPONENT-ICON-MASK)" },
            React.createElement("path", { d: "M0 0h24v24H0z" }))))); };
exports.School = School;
//# sourceMappingURL=School.js.map